import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/fonts/fonts.scss";
import "./Global.scss";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// REACT_APP_SITE is inlined at build time, so only the chosen site is bundled.
const App =
	process.env.REACT_APP_SITE === "automated-offers"
		? require("./AutomatedOffersApp").default
		: require("./App").default;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);

reportWebVitals();
